import React, { useState, useContext } from 'react';
import cn from 'classnames';
import useSWR from 'swr';
import { AppContext } from 'Context';
import { dataFetcher, endpoints } from 'Api';
import { Collapse, Zoom } from '@material-ui/core';
import styles from './index.module.css';

const transitionTimeout = 300;

const UserRequest = ({ email, id, firstname, lastname, setSnackbar, setSuccessor, successors }) => {
  const [isVisible, setVisibility] = useState(true);
  const [selectedSuccessor, selectSuccessor] = useState(undefined);
  const { langText } = useContext(AppContext);
  const commonText = langText?.common;
  const { isValidating: deletingUser, mutate: deleteUser } = useSWR([endpoints.removeSuccessor, id], {
    fetcher: (url, userId) => dataFetcher(url, { user_id: userId }),
    onSuccess: ({ success }) => {
      if (success) {
        setSnackbar({
          isVisible: true,
          message: `${firstname ? `${firstname}` : 'User'} removed`
        });
      } else {
        setSnackbar({ isVisible: true, message: 'Oops! Something went wrong', type: 'error' });
      }
      setVisibility(false);
    },
    onError: () => {
      setSnackbar({ isVisible: true, message: 'Oops! Something went wrong', type: 'error' });
    },
  });

  return (
    <Collapse in={isVisible} timeout={transitionTimeout}>
      <Zoom in={isVisible} timeout={transitionTimeout}>
        <div className={styles.userRequest}>
          <div>
            <div className={styles.profileIcon}>
              {`${firstname ? firstname.charAt(0).toUpperCase() : email.charAt(0).toUpperCase()}`}
            </div>
            <div className={styles.userRequestText}>
              <div className={styles.userRequestName}>{`${firstname} ${lastname}`}</div>
              <div className={styles.userRequestEmail}>{email}</div>
            </div>
          </div>
          <div className={styles.userRequestActionsContainer}>
            <button
              className={cn({ [styles.userRequestActionButton]: true, [styles.delete]: true, [styles.deleteActive]: true })}
              onClick={() => { deleteUser(); }}
            >
              {deletingUser ? `${(commonText?.removing || 'Removing')}...` : (commonText?.remove || 'Remove')}
            </button>
          </div>
        </div>
      </Zoom>
    </Collapse>
  );
};
export default UserRequest;
